import { Pipe, PipeTransform } from '@angular/core';
import { differenceInYears, differenceInMonths } from 'date-fns';
import { TranslateService } from '@ngx-translate/core';

@Pipe({
  name: 'durationSince',
  pure: true
})
export class DurationSincePipe implements PipeTransform {
  constructor(private readonly translate: TranslateService) {}

  transform(startDate: string | Date, leaveDate?: string | Date | null): string {
    if (!startDate) return '';

    const start = new Date(startDate);
    const end = leaveDate ? new Date(leaveDate) : new Date();

    if (isNaN(start.getTime()) || isNaN(end.getTime()) || start > end) return '';

    const years = differenceInYears(end, start);
    const months = differenceInMonths(end, start) - years * 12;

    let result = '';

    if (years === 0 && months === 0) {
      result = this.translate.instant('duration.less_than_month');
    } else if (years === 0) {
      result = this.translate.instant('duration.months', { months });
    } else if (months === 0) {
      result = this.translate.instant('duration.years', { years });
    } else {
      result = this.translate.instant('duration.years_months', { years, months });
    }

    return result ? `${result}` : '';
  }
}
